import { render, staticRenderFns } from "./Percentiles.vue?vue&type=template&id=20c355a6"
import script from "./Percentiles.vue?vue&type=script&lang=js"
export * from "./Percentiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports